import React from "react";
import { Box } from "@bca/ui-library";

const Grade4SVG: React.FunctionComponent = () => (
  <Box display="flex">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#FCC800"/>
      <path d="M15.657 13.281v1.545h-7.17L8.39 13.63l4.149-6.583h1.566L12.41 9.884l-2.064 3.397h5.311ZM14.53 7.047V17H12.56V7.047h1.97Z" fill="#fff"/>
    </svg>
  </Box>
);

export default Grade4SVG;
